import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AuthProvider } from './context/AuthContext';
import { LanguageProvider } from './context/LanguageContext';
import { GaugeSimulationProvider } from './context/GaugeSimulationContext';
import { ConfirmProvider } from './context/ConfirmContext';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import S475Detail from './pages/S475Detail';
import Users from './pages/Users';
import Companies from './pages/Companies';
import Devices from './pages/Devices.js';
import Checkin from './pages/Checkin';
import Me from './pages/Me';
import MeSettings from './pages/MeSettings';
import ChangePassword from './pages/ChangePassword';
import Notification from './pages/Notification';
import Konfigurimi from './pages/Konfigurimi';
import Control from './pages/Control';
import Reports from './pages/Reports';
import Alarms from './pages/Alarms';
import './App.css';
import './styles/Login.css';

function App() {
  return (
    <AuthProvider>
      <LanguageProvider>
        <ConfirmProvider>
          <BrowserRouter>
            <GaugeSimulationProvider>
              <Toaster position="top-center" richColors closeButton theme="dark" />
              <Routes>
                <Route path="/login" element={<Login />} />

                <Route
                  path="/dashboard"
                  element={
                    <ProtectedRoute>
                      <Dashboard />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/control"
                  element={
                    <ProtectedRoute requiredRoles={['SUPERADMIN', 'ADMIN']}>
                      <Control />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/users"
                  element={
                    <ProtectedRoute requiredRoles={['SUPERADMIN', 'ADMIN']}>
                      <Users />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/companies"
                  element={
                    <ProtectedRoute requiredRoles={['SUPERADMIN']}>
                      <Companies />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/devices"
                  element={
                    <ProtectedRoute>
                      <Devices />
                    </ProtectedRoute>
                  }
                />

                {/* S475 device detail */}
                <Route
                  path="/devices/s475/:deviceId"
                  element={
                    <ProtectedRoute>
                      <S475Detail />
                    </ProtectedRoute>
                  }
                />
                <Route path="/devices/:id" element={<Navigate to="/devices" replace />} />

                <Route
                  path="/checkin"
                  element={
                    <ProtectedRoute>
                      <Checkin />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/reports"
                  element={
                    <ProtectedRoute>
                      <Reports />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/alarms"
                  element={
                    <ProtectedRoute>
                      <Alarms />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/me"
                  element={
                    <ProtectedRoute>
                      <Me />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/me/settings"
                  element={
                    <ProtectedRoute>
                      <MeSettings />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/me/notifications"
                  element={
                    <ProtectedRoute>
                      <Notification />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/me/konfigurimi"
                  element={
                    <ProtectedRoute requiredRoles={['SUPERADMIN']}>
                      <Konfigurimi />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/me/change-password"
                  element={
                    <ProtectedRoute>
                      <ChangePassword />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/settings"
                  element={
                    <ProtectedRoute>
                      <Dashboard />
                    </ProtectedRoute>
                  }
                />

                <Route path="/" element={<Navigate to="/dashboard" replace />} />
              </Routes>
            </GaugeSimulationProvider>
          </BrowserRouter>
        </ConfirmProvider>
      </LanguageProvider>
    </AuthProvider>
  );
}

export default App;
